import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="legal-page" data-testid="terms-page">
      <Link to="/" className="ghost-link" style={{ display: "inline-block", marginBottom: 40 }}>Back to Pord.</Link>

      <h1 className="page-title" style={{ fontSize: "clamp(1.8rem,5vw,2.8rem)", marginBottom: 8 }}>Terms of Service</h1>
      <p className="muted-caption">Effective: April 11, 2026 | Last updated: April 11, 2026</p>

      <h3>1. About Pord.</h3>
      <p>Pord. is an educational investment platform in pre-launch development, operated by EnQUIPs LLC. These Terms apply to the landing page, the capsule scenario, and waitlist signup at pordapp.com.</p>

      <h3>2. Educational Purpose Only</h3>
      <p>Pord. is designed solely for financial education. Nothing on this website constitutes investment, financial, tax, or legal advice or a recommendation to buy, sell, or hold any security or financial instrument. See <Link to="/privacy" className="ghost-link" style={{ textDecoration: "underline" }}>Privacy Policy & Disclaimer</Link> for the full educational disclaimer.</p>

      <h3>3. Eligibility</h3>
      <p>You must be 18 or older to use this website or join the waitlist. By submitting your information, you confirm that you meet this requirement.</p>

      <h3>4. Waitlist Participation</h3>
      <p>Joining the waitlist does not guarantee platform access, any specific pricing, or any particular feature. Waitlist position and early access timing are at EnQUIPs's sole discretion.</p>

      <h3>5. Acceptable Use</h3>
      <p>You agree not to:</p>
      <ul>
        <li>Use this website for any unlawful purpose</li>
        <li>Attempt to scrape, reverse-engineer, or interfere with any part of this website</li>
        <li>Submit false or misleading information</li>
        <li>Represent any Pord. content as personalized financial advice to others</li>
      </ul>

      <h3>6. Intellectual Property</h3>
      <p>All content on this website — including the Capsule Scenario, copy, design, and audio — is the intellectual property of EnQUIPs LLC. You may not reproduce, redistribute, or commercially use any part of it without prior written permission.</p>

      <h3>7. Disclaimers</h3>
      <p>This website is provided "as is" without warranties of any kind. EnQUIPs does not warrant that the site will be uninterrupted or error-free, or that any content is accurate, complete, or suitable for your specific situation.</p>

      <h3>8. Limitation of Liability</h3>
      <p>To the maximum extent permitted by law, EnQUIPs LLC shall not be liable for any indirect, incidental, or consequential damages arising from your use of this website or reliance on its content.</p>

      <h3>9. Privacy</h3>
      <p>Your use of this website is governed by <Link to="/privacy" className="ghost-link" style={{ textDecoration: "underline" }}>Privacy Policy</Link>, incorporated here by reference.</p>

      <h3>10. Changes</h3>
      <p>We may update these Terms as the platform develops. The "Last Updated" date will reflect the most recent revision. Continued use constitutes acceptance.</p>

      <div style={{ marginTop: 60 }}>
        <Link to="/" className="cta-pill" data-testid="back-to-pord-btn">Back to Pord.</Link>
      </div>
    </div>
  );
}
